export default __webpack_public_path__ + "static/media/lightbg.47592701.png";